import { WaterUserDepositStatus } from '@/core/enums/global.enums';
import { DatabaseRecord } from '../../repos/table.repo';

interface ContractModelExt {
    tollAreaName?: string,
    unitTypeName?: string,
    notificationMethodArray?: string[],
    paymentMethodArray?: string[]
}
export interface ContractModel extends DatabaseRecord, ContractModelExt {
    name: string;
    code: string;
    tollAreaId: string;
    phone: string;
    bank: string;
    bankNo: string;
    waterMeterCode: string;
    address: string;
    userName: string;
    unitTypeId: string;
    waterFactoryId: string;
    status: string;
    notificationMethod?: string;
    paymentMethod?: string;
    gps: string;
    organization: string;
    lastWaterMeterNumber: number;
    lastReadDate?: string;
    identityNo: string;
    identityDate?: string;
    identityPlace: string;
    identityProPlace?: string;
    identityCode: number;
    supportCashRate?: number;
    numberOfPeople?: number;
    externalId: string;
    note: string;
    requiredDepositAmount?: number;
    depositAmount?: number;
    collector: string;
    collectionDate?: string;
    depositStatus: string;
    waterMeterName: string;
    waterMeterType: string;
    normalizeName: string;
    email: string;
    taxCode: string;
    meterSetupDate?: string;
    createdBy: string;
    updatedBy: string;
    createdAt: string;
    updatedAt: string;
    waterMeterMaxIndex?: number | null;
}

export class ContractModelFactory {
    static getEmpty() {
        return {
            id: "",
            name: "",
            code: "",
            tollAreaId: "",
            phone: "",
            bank: "",
            bankNo: "",
            waterMeterCode: "",
            address: "",
            userName: "",
            unitTypeId: "",
            waterFactoryId: "",
            status: "",
            notificationMethod: "",
            paymentMethod: "",
            gps: "",
            organization: "",
            lastWaterMeterNumber: 0,
            lastReadDate: "",
            identityNo: "",
            identityProPlace: "",
            identityPlace: "",
            identityCode: 0,
            supportCashRate: 0,
            numberOfPeople: 0,
            externalId: "",
            note: "",
            requiredDepositAmount: 0,
            depositAmount: 0,
            collector: "",
            depositStatus: "",
            waterMeterName: "",
            waterMeterType: "",
            normalizeName: "",
            email: "",
            taxCode: "",
            meterSetupDate: "",
            createdBy: "",
            updatedBy: "",
            createdAt: "",
            updatedAt: "",
        }
    }
}

export interface DepositSummaryModel {
    status: WaterUserDepositStatus;
    statusAmount: number;
    requiredDepositAmount: number;
    depositAmount: number;
}
